import type Invoice from '@/entities/invoice';

type InvoiceState = Pick<Invoice, 'status' | 'invoiceStatus' | 'finalizedOn'>;
type InvoiceLine = {id: string; invoiceId?: string | null};
export type InvoiceLookup = {
    get: (id: string) => Invoice | null | undefined;
    values: () => readonly Invoice[];
};

export function isFinalizedInvoice(invoice: InvoiceState | null | undefined): boolean {
    return invoice?.status !== 'D' && invoice?.invoiceStatus === 'F' && !!invoice.finalizedOn;
}

function isLineLocked(line: InvoiceLine, invoices: InvoiceLookup,
                      fields: readonly ('taskIds' | 'taskPositions' | 'flatFeeIds' | 'flatFeeMilestoneIds')[]): boolean {
    if (line.invoiceId && isFinalizedInvoice(invoices.get(line.invoiceId))) return true;
    return invoices.values().some(invoice => isFinalizedInvoice(invoice)
        && fields.some(field => invoice[field]?.includes(line.id)));
}

export function isTaskLockedByFinalizedInvoice(task: InvoiceLine, invoices: InvoiceLookup): boolean {
    return isLineLocked(task, invoices, ['taskIds', 'taskPositions']);
}

/** Starting and editing the timer change the same locked billing values. */
export const isTaskTimerLockedByFinalizedInvoice = isTaskLockedByFinalizedInvoice;

export function isFlatFeeLockedByFinalizedInvoice(fee: InvoiceLine, invoices: InvoiceLookup): boolean {
    return isLineLocked(fee, invoices, ['flatFeeIds']);
}

export function isMilestoneLockedByFinalizedInvoice(milestone: InvoiceLine, invoices: InvoiceLookup): boolean {
    return isLineLocked(milestone, invoices, ['flatFeeMilestoneIds']);
}

/** A finalized invoice's task line is a frozen proxy built from finalValues (FinancialHelper.getFinalizedInvoiceTaskLines). */
export function isFinalizedSnapshotLine(task: object | null | undefined): boolean {
    return !!task && '_finalCost' in task && '_finalHours' in task;
}
